const Table = () => {
    return (
        <table className="table">
            <thead>
                <tr>
                    <th>Series</th>
                    <th>1 mth</th>
                    <th>3 mth</th>
                    <th>6 mth</th>
                    <th>1 yr</th>
                    <th>3 yr</th>
                    <th>5 yr</th>
                    <th>10 yr</th>
                    <th>Since Inception</th>
                </tr>
            </thead>
            <tbody>
                <tr className="show-all false">
                    <td>Series A</td>
                    <td>2.7</td>
                    <td>-1.8</td>
                    <td>-3.8</td>
                    <td>0.1</td>
                    <td>5.4</td>
                    <td>4.2</td>
                    <td>5.9</td>
                    <td>8.1</td>
                </tr>
                <tr className="show-all false">
                    <td>Series B</td>
                    <td>6.7</td>
                    <td>5.6</td>
                    <td>1.2</td>
                    <td>-6.7</td>
                    <td>4.2</td>
                    <td>-0.9</td>
                    <td>4.9</td>
                    <td>3.6</td>
                </tr>
                <tr className="show-all false">
                    <td>Series C</td>
                    <td>-0.4</td>
                    <td>0.7</td>
                    <td>-3.8</td>
                    <td>2.1</td>
                    <td>8.4</td>
                    <td>4.6</td>
                    <td>3.6</td>
                    <td>9.0</td>
                </tr>
            </tbody>
        </table>
    );
};

export default Table;
